import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import * as styles from './style.module.scss';
import LanguageSwitcher from '../LanguageSwitcher';
import Place from '../../networking/resources/Place';

export default function PoweredBy({
  restaurantInfo,
  lang,
}) {
  const { t } = useTranslation();

  let secondLanguage = lang;
  if (lang === 'en') {
    secondLanguage = restaurantInfo.city.country.code.toLowerCase();
  }

  return (
    <div className={styles['powered-by']}>
      {t('title')}
      {lang && (
        <LanguageSwitcher locales={['en', secondLanguage]} />
      )}
    </div>
  );
}

PoweredBy.propTypes = {
  restaurantInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(Place)]).isRequired,
  lang: PropTypes.string,
};

PoweredBy.defaultProps = {
  lang: null,
};
